export default function UpgradeIcon({
  color = "success"
}: {
  color?: "success" | "secondary"
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 18 18"
    >
      <g
        id="Group_10072"
        data-name="Group 10072"
        transform="translate(19415 -22220)"
      >
        <circle
          id="Ellipse_390"
          data-name="Ellipse 390"
          cx="9"
          cy="9"
          r="9"
          transform="translate(-19415 22220)"
          fill={color === "secondary" ? "#fdfdfd" : "#20b41c"}
        />
        <g id="arrow-up-short" transform="translate(-19417 22218.014)">
          <path
            id="Path_4963"
            data-name="Path 4963"
            d="M11,7.563a.688.688,0,0,1,.688.688v6.875a.688.688,0,0,1-1.375,0V8.25A.688.688,0,0,1,11,7.562Z"
            fill={color === "secondary" ? "#000" : "#fdfdfd"}
            fillRule="evenodd"
          />
          <path
            id="Path_4964"
            data-name="Path 4964"
            d="M10.513,6.388a.688.688,0,0,1,.973,0l4.125,4.125a.688.688,0,0,1-.973.973L11,7.847l-3.638,3.64a.688.688,0,1,1-.973-.973l4.125-4.125Z"
            fill={color === "secondary" ? "#000" : "#fdfdfd"}
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  )
}
